import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { inject, observer } from 'mobx-react';

import globalTranslations from '../../../i18n/globalTranslations';
import RequestState from '../../../types/RequestState';
import { modelOf } from '../../../prop-types';
import CartStore from '../../../store/CartStore';
import Order from '../../../models/Order';

@observer
export class OrderCloneButton extends Component {
  handleAddFromOrder = () => {
    const { order, cartStore } = this.props;

    // If cartStore is already loading, don't do anything
    if (cartStore.state === RequestState.LOADING) {
      return;
    }

    if (cartStore.cart) {
      cartStore.addFromOrder(order.id).catch((e) => {
        console.error(e);
      });
    }
  };

  render() {
    const { cartStore } = this.props;

    return (
      <Button
        className="OrderCloneButton"
        color="primary"
        disabled={cartStore.state !== RequestState.LOADED}
        onClick={() =>
          window.confirm(
            this.props.intl.formatMessage(
              globalTranslations.confirmAddToCartTitle
            )
          ) && this.handleAddFromOrder()
        }
      >
        <FormattedMessage {...globalTranslations.cloneOrder} />
      </Button>
    );
  }
}

OrderCloneButton.propTypes = {
  cartStore: modelOf(CartStore).isRequired,
  order: modelOf(Order),
  intl: intlShape.isRequired
};

export default inject('cartStore')(injectIntl(OrderCloneButton));



// WEBPACK FOOTER //
// ./src/components/order/OrderCloneButton/index.jsx